import moment from "moment-jalaali";

const TEST = "TEST";
const CHART_LEAVE = "CHART_LEAVE";
const Chart_Absence = "Chart_Absence";
/**
 *
 * @param {mix} data
 * @return {{type: string, data: *}}
 */
function success(data) {
  return {
    type: TEST,
    data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  console.log("paylodscdsad", payload);
  return {
    type: CHART_LEAVE,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccessChartAbsence(payload) {
  console.log("paylodscdsad", payload);
  return {
    type: Chart_Absence,
    payload: payload,
  };
}

/////////////////////////////////////////////////////////
/**
 *
 * @return {Function}
 */
export function test() {
  return (dispatch, getState, api) => {
    api
      .get("/")
      .then((r) => {
        //  console.log(3);
        dispatch(success(r));
      })
      .catch((r) => {
        // console.log(4);
      });
  };
}
/**
 *
 * @return {Function}
 */
export function ChartAbsence(params = {}, callback = () => {}) {
  console.log("paramsparams", params);
  return (dispatch, getState, api) => {
    api
      .get(
        `https://api.tikment.ir/Home/ChartAbsence?DateFrom=${
          params.DateFrom ? params.DateFrom : moment().format("YYYY-MM-DD")
        }&DateTo=${
          params.DateTo ? params.DateTo : moment().format("YYYY-MM-DD")
        }`
      )
      .then((r) => {
        //  console.log(3);
        dispatch(_indexSuccessChartAbsence(r));
        callback(r);
        console.log("RRRRRRRR", r);
      })
      .catch((r) => {
        // console.log(4);
      });
  };
}

/**
 *
 * @return {Function}
 */
export function ChartLeave(params = {}, callback = () => {}) {
  return (dispatch, getState, api) => {
    api
      .get(
        `https://api.tikment.ir/Home/ChartLeave?DateFrom=${
          params.DateFrom ? params.DateFrom : moment().format("YYYY-MM-DD")
        }&DateTo=${
          params.DateTo ? params.DateTo : moment().format("YYYY-MM-DD")
        }`
      )
      .then((r) => {
        //  console.log(3);
        dispatch(_indexSuccess(r));
        callback(r);
        console.log("RRRRRRRR", r);
      })
      .catch((r) => {
        // console.log(4);
      });
  };
}
///////////////////////////////////////////////////////////////////
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    test: 1,
    post: {},
  },
  action
) {
  switch (action.type) {
    case TEST:
      break;
    case CHART_LEAVE:
      console.log("action.payload", action.payload);
      return Object.assign({}, state, {
        leave: action.payload.data.leave,
      });
    case Chart_Absence:
      console.log("action.payload", action.payload);
      return Object.assign({}, state, {
        absence: action.payload.data.absence,
      });

    default:
      return state;
  }
}
